export const actionKey = '@@topic';

// a 'special' topic
export const AI_TOPIC_ID = 1505;
